const isPast = (time: string | Date) => new Date(time).getTime() < new Date().getTime()

export default isPast